import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "styles/microsite.module.scss";
import "styles/components/featureSlider.module.scss";
import "slick-carousel/slick/slick-theme.css";
import ChemicalResistant from "/assets/Pictures/jotafloor/Chemical_Resistant@2x.png";
import Crack from "/assets/Pictures/jotafloor/Crack-Bridging@2x.png";
import Cleaning from "/assets/Pictures/jotafloor/Easy-Cleaning@2x.png";
import ImpactResistant from "/assets/Pictures/jotafloor/Impact_Resistant@2x.png";
import MultipleColor from "/assets/Pictures/jotafloor/Multiple-Colours@2x.png";
import Mechanical from "/assets/Pictures/jotafloor/Superior-Mechanical@2x.png";
import TechService from "/assets/Pictures/jotafloor/Tech-Service@2x.png";
import UVResistant from "/assets/Pictures/jotafloor/UV-Resistant@2x.png";
import Abraison from "/assets/Pictures/jotafloor/abraison.png";
import WaterResistance from "/assets/Pictures/jotafloor/Waterproof@2x.png";
import Elongation from "/assets/Pictures/jotafloor/elongation-blue.png";

function FeaturesSlide({ slideIcon, slideText }) {
  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    //autoplay: true,
    //autoplaySpeed: 2000,
    // prevArrow: <SamplePrevArrow/>,
    //     nextArrow:  <SampleNextArrow/>,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div>
        <div className="feature-item">
            <img
              src={slideIcon}
              placeholder="blur"
              width="100"
              height="100"
              layout="responsive"
              className="img_fluid"
              alt={slideText}
              priority
            />
            <h3>{slideText}</h3>
          </div>
      </div>
    </>
  );
}
export default FeaturesSlide;
